import { render, staticRenderFns } from "./otchetStudent.vue?vue&type=template&id=434609f8"
import script from "./otchetStudent.vue?vue&type=script&lang=js"
export * from "./otchetStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports